import { Charger, ChargerConnector } from "./charger";
import { LocationListItem } from "./location";
import { PricingConditionModel } from "./pricingCondition";
import { UserModel } from "./user";

export enum ChargingSessionState {
  Pending,
  InProgress,
  Parking,
  Finished,
  FailedToSetChargingProfile,
}

export enum PaymentStatus {
  FREE,
  PAID,
  UNPAID,
  ROAMING,
}

export enum PaymentInterval {
  INSTANT,
  MONTHLY,
  ROAMING,
}

export enum ChargingInitSources {
  SEAK,
  HUBJECT,
  VILLAPRO,
  PLUGNCHARGE,
  QVEND
}

export type ChargingSession = {
    id: string;
    startedAt: Date;
    endedAt: Date;
    startedParkingAt: Date;
    length: number;
    consumedWh: number;
    importedWh: number;
    offeredWh: number;
    price: number;
    user: UserModel;
    location: LocationListItem;
    charger: Charger;
    chargingConnector: ChargerConnector;
    chargingConnectorId: string;
    state: ChargingSessionState;
    hasInvoice: boolean;
    errorCause: string;
    idTag: string;
    paid: boolean;
    paymentInterval: PaymentInterval;
    pricingCondition: PricingConditionModel;
    whitelistAuthentication: boolean;
    chargerExternalId: string;
    connectorExternalId: number;
    paymentStatus: PaymentStatus;
    chargingPrice: number;
    parkingPrice: number;
    chargingInitSource: ChargingInitSources;
    hjIdentificationValue: string;
    qVendQid: string | null;
};
